import { render } from "./BuildingAgeEditing.vue?vue&type=template&id=5181d0ca&ts=true"
import script from "./BuildingAgeEditing.vue?vue&type=script&lang=ts"
export * from "./BuildingAgeEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__